((host) => {
  const measure = (items, eligible) => {
    const allowed = new Set(eligible.map(String));
    const lines = items.filter(item => allowed.has(String(item.variant_id || item.id)));
    const count = lines.reduce((total, item) => total + item.quantity, 0);
    const percent = count >= 6 ? 25 : count >= 2 ? (count - 1) * 5 : 0;
    const retail = lines.reduce((sum, item) => sum + item.original_price * item.quantity, 0);
    const savings = lines.reduce((sum, item) => sum + Math.round(item.original_price * item.quantity * percent / 100), 0);
    return { count, percent, retail, savings, subtotal: retail - savings, water: count >= 6 ? 30 : count >= 4 ? 10 : 0 };
  };
  const inspect = (cart, config) => {
    const allowed = new Set(config.eligible.map(String));
    const lines = cart.items.filter(item => allowed.has(String(item.variant_id)));
    const count = lines.reduce((total, item) => total + item.quantity, 0);
    const percent = count >= 6 ? 25 : count >= 2 ? (count - 1) * 5 : 0;
    const giftId = count >= 6 ? config.water30 : count >= 4 ? config.water10 : null;
    const gifts = cart.items.filter(item => item.properties?._free_product === 'true' && item.properties?._kite_promo_name === config.giftTitle);
    const correctGift = giftId ? gifts.length === 1 && String(gifts[0].variant_id) === String(giftId) && gifts[0].quantity === 1 && gifts[0].final_line_price === 0 : gifts.length === 0;
    const correctPrices = lines.every(item => {
      const allocations = (item.line_level_discount_allocations || []).filter(a => a.discount_application?.title?.startsWith('THE LAB MIX — ') && a.discount_application.title.endsWith('% OFF'));
      if (!percent) return allocations.length === 0;
      const expectedTitle = `THE LAB MIX — ${percent}% OFF`;
      return allocations.length === 1 && allocations[0].discount_application.title === expectedTitle && (Math.abs(allocations[0].amount - Math.round(item.original_line_price * percent / 100)) <= 1 || Math.abs(allocations[0].amount - Math.round(item.original_line_price / item.quantity * percent / 100) * item.quantity) <= 1);
    });
    return { count, percent, giftId, settled: correctGift && correctPrices };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { inspect, measure };
  else host.IFLLabMixState = { inspect, measure };
})(typeof window === 'undefined' ? {} : window);
